'use client'

import SearchBar, { SearchBarOptions } from '@/components/UiElements/SearchBar'

type UserSearchProps = {
  onSearch: (value: string) => void
  onAddUserClick: () => void
}

const UserSearch = ({
  onSearch,
  onAddUserClick
}: UserSearchProps) => {
  const options: SearchBarOptions[] = [
    {
      label: 'Add User',
      icon: '',
      iconClassName: 'font-icon-solid',
      onClick: onAddUserClick,
      className: '!px-md',
    },
  ];

  return (
    <SearchBar
      placeholder="Search by user name, last name..."
      onChange={onSearch}
      options={options}
    />
  )
}

export default UserSearch
